import PropTypes from "prop-types";

const DeleteIcon = ({ className }) => (
  <svg
    className={className}
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9687 2.22357L3.51562 4.68342"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.293 2.22357L12.746 4.68342"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.35547 6.18781C1.35547 4.93417 2.02634 4.83252 2.85984 4.83252H13.404C14.2375 4.83252 14.9083 4.93417 14.9083 6.18781C14.9083 7.64474 14.2375 7.5431 13.404 7.5431H2.85984C2.02634 7.5431 1.35547 7.64474 1.35547 6.18781Z"
      stroke="currentColor"
    />
    <path
      d="M6.61328 10.3553V12.7609"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M9.73047 10.3553V12.7609"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M2.37109 7.64471L3.32657 13.4996C3.54342 14.8142 4.0652 15.7764 6.00327 15.7764H10.0895C12.1969 15.7764 12.5086 14.8548 12.7526 13.5809L13.891 7.64471"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

const { string } = PropTypes;

DeleteIcon.propTypes = {
  className: string
};

export default DeleteIcon;
